import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleView } from "../actions";
import HotKeys from "./HotKeys";
import track from "../lib/tracking";

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleStart: () => dispatch(toggleView("location"))
  };
};

class HomeContainer extends Component {
  render() {
    const keyMap = {
      start: "enter",
    };

    const handlers = {
      start: this.props.handleStart,
    };
    return (
      <HotKeys keyMap={keyMap} handlers={handlers}>
        <div className="column column--home">
          <h1 className="title">Welcome to Gruvi's Audience Calculator</h1>
          <p>
            This tool helps you identify audience groups who might be interested in buying or watching your film, tv show, or game.
          </p>
          <p>Click the start button below and follow the steps.</p>
          <a onClick={() => {track("start_button");this.props.handleStart();}} className="button button--start">
            START
          </a>
        </div>
      </HotKeys>
    );
  }
}

const Home = connect(null, mapDispatchToProps)(HomeContainer);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js